import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge as BootstrapBadge } from "reactstrap";

import "./Badge.scss";

/**
 * Badge component for displaying various states and information
 * 
 * @component
 * @example
 * <Badge color="primary" size="medium">New</Badge>
 * <Badge type="floating" color="danger">8</Badge>
 */
export const Badge = ({ 
  type = 'normal', 
  color = 'primary', 
  size = 'normal', 
  className = '', 
  children, 
  ...rest 
}) => {
  const badgeClasses = classNames(
    className,
    {
      'badge-sm': size === 'small',
      'badge-md': size === 'medium',
      'badge-lg': size === 'large',
      'badge-circle badge-floating border-white': type === 'floating',
      'badge-circle badge-pad border-white': type === 'pad'
    }
  );
  
  return (
    <BootstrapBadge
      className={badgeClasses}
      color={color}
      pill
      {...rest}
    >
      {children}
    </BootstrapBadge>
  );
};

// Badge.propTypes = {
//   /** Badge element size */
//   size: PropTypes.oneOf(['normal', 'small', 'medium', 'large']),
//   /** Badge element color */
//   color: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']),
//   /** Badge element type */
//   type: PropTypes.oneOf(['normal', 'floating', 'pad']),
//   /** Additional classes for Badge element */
//   className: PropTypes.string,
//   /** Badge element content */
//   children: PropTypes.node
// }; 